import React, { lazy } from "react";
import NavigationPatients from "@brightinsight/bi-web-core/assets/NavigationPatients.svg";

export class RouteConstants {
  // Lazy load the PatientContainer component with a webpack chunk name "Patient"
  static PatientListContainer = lazy(
    () => import(/* webpackChunkName: "Patient" */ "../layout/PatientListContainer")
  );

  // Define module routes for the patients module
  static readonly MODULE_ROUTES = [
    {
      path: "/patients/list", // URL path for the patients list
      component: React.createElement(RouteConstants.PatientListContainer), // Component to render for this route
      actionName: "view", // Action name associated with this route
      displayName: "Patients List", // Display name for the route
      isMenu: true, // Indicates if this route should be shown in the menu
      icon: NavigationPatients,
    },
  ];
}
